/* eslint-disable react-func/max-lines-per-function */
/* eslint-disable sonarjs/cognitive-complexity */
var ScrollElementToTarget = function ScrollElementToTarget(el, target, maxSize) {
  if (target.getBoundingClientRect().bottom + maxSize >= window.innerHeight) {
    var combinedHeight = target.getBoundingClientRect().height + maxSize;
    var topCombine = el.scrollTop + target.getBoundingClientRect().top;
    var windowDifference = window.innerHeight - combinedHeight;
    if (el === window) {
      el.scrollBy(0, target.getBoundingClientRect().top - windowDifference);
    } else {
      el.scrollTop = topCombine - windowDifference;
    }
  }
};

/**
 * creates some helper methods for the window object
 * @param {object} windowObject - overrides the window object
 */
var WindowHelperWrapper = function WindowHelperWrapper() {
  var windowObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  windowObject = windowObject || (typeof window === 'undefined' ? {} : window);

  /**
   * sets the window's location to the passed URL
   * @param {string} destUrl
   */
  var open = function open(destUrl, target) {
    if (windowObject.open) windowObject.open(destUrl, target);
  };

  /**
   * sets the window's location to the passed URL
   * @param {string} destUrl
   */
  var redirect = function redirect(destUrl) {
    windowObject.location.assign(destUrl);
  };

  /**
   * sets the window's location to the passed URL
   * @param {string} destUrl
   */
  var reload = function reload() {
    windowObject.location.reload();
  };

  /**
   * Gets the current window's pixel dimensions
   * @returns {object} { width, height }
   */
  var getDimensions = function getDimensions(element) {
    return element ? {
      width: element.clientWidth,
      height: element.clientHeight
    } : {
      width: windowObject.innerWidth || windowObject.document.body.clientWidth,
      height: windowObject.innerHeight || windowObject.document.body.clientHeight
    };
  };

  /**
   * Watches the window's resize event and returns the index of the matching
   * breakpoint
   * @param {array|number} breakpoints
   * @param {function(number)} onBreakpointChange whenever the breakpoint changes
   * @param {'x'|'y'} direction x or y
   * @returns {function} call to destroy the watcher
   */
  var watchBreakpoints = function watchBreakpoints(points, onBreakpointChange) {
    var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
    var element = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    function setBreakpoint() {
      var dimensions = getDimensions(element);
      var dimension = direction === 'y' ? dimensions.height : dimensions.width;
      var index;
      for (index = 0; index < count; index++) {
        var point = points[index];
        if (dimension < point) {
          break;
        }
      }
      if (index !== breakpoint) {
        breakpoint = index;
        onBreakpointChange(breakpoint);
      }
    }
    points = Array.isArray(points) ? points : [points];
    var count = points.length;
    var breakpoint;
    setBreakpoint();
    windowObject.addEventListener('resize', setBreakpoint);
    return function () {
      windowObject.removeEventListener('resize', setBreakpoint);
    };
  };
  return {
    open: open,
    redirect: redirect,
    getDimensions: getDimensions,
    watchBreakpoints: watchBreakpoints,
    reload: reload
  };
};

/** WindowHelper methods using the window object */
var WindowHelper = WindowHelperWrapper();
export { ScrollElementToTarget, WindowHelper, WindowHelperWrapper };